import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
export function ContextResults() {
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };
  return;
}
function ResultCard({
  title,
  subtitle,
  description
}: {
  title: string;
  subtitle: string;
  description: string;
}) {
  return <div className="bg-gray-900 rounded-xl border border-gray-800 overflow-hidden flex flex-col h-full p-8" data-id="element-421">
      <h3 className="text-white font-bold font-['Syne'] text-2xl mb-3" data-id="element-422">
        {title}
      </h3>
      <p className="text-[#0066FF] font-semibold text-lg mb-4" data-id="element-423">{subtitle}</p>
      <p className="text-gray-400 leading-relaxed" data-id="element-424">{description}</p>
    </div>;
}